import React, { FC, useState } from 'react';
import { Avatar, Box } from '@mui/material';

type SupplierLogoProps = {
    name?: string | null;
    logoSignedUrl?: string | null;
};

const initialsOf = (name?: string | null) =>
    (name ?? '')
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((word) => word[0]?.toUpperCase())
        .join('');

/** The lab's logo, or its initials when it has none or the link fails to load. */
const SupplierLogo: FC<SupplierLogoProps> = ({ name, logoSignedUrl }) => {
    const [hasFailed, setHasFailed] = useState(false);
    if (logoSignedUrl && !hasFailed) {
        return (
            <Box
                component="img"
                src={logoSignedUrl}
                alt={name ?? ''}
                onError={() => setHasFailed(true)}
                sx={{ width: 56, height: 56, objectFit: 'contain', flexShrink: 0 }}
            />
        );
    }
    return <Avatar sx={{ width: 56, height: 56 }}>{initialsOf(name)}</Avatar>;
};

export default SupplierLogo;
